import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Seo from "../../Seo";
import { SITE_ORIGIN } from "../../../config/site";
import L from "../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import { yandexMetrikaParams } from "../../../analytics/yandexMetrika";
import MarketingShell from "../MarketingShell";
import { getBlogPost } from "../blog/posts";
import { MARKETING_PATHS } from "../marketingNav";
import s from "../marketing.module.css";

function formatDate(iso) {
  try {
    return new Intl.DateTimeFormat("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getBlogPost(slug);

  useEffect(() => {
    if (post) yandexMetrikaParams({ landing: "blog_post", slug: post.slug });
  }, [post]);

  if (!post) {
    return <Navigate to={MARKETING_PATHS.blog} replace />;
  }

  const path = `${MARKETING_PATHS.blog}/${post.slug}`;
  const onTry = () => trackTryClick({ landing: "blog_post", slug: post.slug });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: post.title,
      description: post.description,
      datePublished: post.date,
      dateModified: post.date,
      author: {
        "@type": "Organization",
        name: L.productName,
        url: SITE_ORIGIN,
      },
      publisher: {
        "@type": "Organization",
        name: L.productName,
        url: SITE_ORIGIN,
      },
      mainEntityOfPage: `${SITE_ORIGIN}${path}`,
      inLanguage: "ru-RU",
    },
  ];

  return (
    <MarketingShell metrikaLanding="blog_post">
      <Seo
        title={post.title}
        description={post.description}
        canonicalUrl={`${SITE_ORIGIN}${path}`}
        keywords={post.tags}
        ogType="article"
        jsonLd={jsonLd}
      />

      <article className={s.article}>
        <p className={s.articleMeta}>
          <Link to={MARKETING_PATHS.blog}>Блог</Link>
          {" · "}
          {formatDate(post.date)}
        </p>
        <h1>{post.title}</h1>
        <p className={s.articleLead}>{post.lead}</p>
        <div className={s.articleBody}>
          {post.sections.map((section) => (
            <section key={section.h2}>
              <h2>{section.h2}</h2>
              {(section.paragraphs || []).map((p) => (
                <p key={p}>{p}</p>
              ))}
              {section.bullets?.length ? (
                <ul>
                  {section.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
        </div>
      </article>

      <section className={s.ctaBand}>
        <h2>Попробуйте на своей секции</h2>
        <p>{TRIAL_DAYS} дней бесплатно. Карту указывать не нужно.</p>
        <Link
          to={MARKETING_PATHS.buy}
          className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
          onClick={onTry}
        >
          Создать клуб
        </Link>
      </section>
    </MarketingShell>
  );
}
